import { Menu, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import DocumentManagementLayout from '../DocumentManagementLayout'
import {
  DocumentManagementTabContent,
  DocumentManagementTabLayout,
} from '../DocumentManagementStyled'

// Dưới ngưỡng này, tabs chuyển từ dọc (bên trái) sang ngang (phía trên)
// để màn hình nhỏ không bị vỡ.
const HORIZONTAL_TABS_BREAKPOINT = 1024

const ConnectedCommiteeDocumentLayout = props => {
  const history = useHistory()
  const [activeKey, setActiveKey] = useState('organization')
  const [isHorizontalTabs, setIsHorizontalTabs] = useState(
    window.innerWidth < HORIZONTAL_TABS_BREAKPOINT
  )
  const pathName = window.location.pathname

  useEffect(() => {
    const handleWindowResize = () =>
      setIsHorizontalTabs(window.innerWidth < HORIZONTAL_TABS_BREAKPOINT)
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  const onChangeTabs = key => {
    let path = '/document-management/connected-committee-document'
    if (props.historyPath) {
      path = props.historyPath
    }
    history.push(`${path}/${key}`)
  }

  return (
    <DocumentManagementLayout selectedKey="connected-committee-document">
      <DocumentManagementTabLayout>
        <Tabs
          className="custom-ant-vertical-tabs hide-tab-content"
          tabPosition={isHorizontalTabs ? 'top' : 'left'}
          activeKey={activeKey}
          onChange={onChangeTabs}>
          <Tabs.TabPane tab="Công ty nhận" key="organization" />
        </Tabs>
        <div
          style={{
            flexGrow: 1,
            minWidth: 0,
            padding: '20px',
            borderRadius: '16px',
            backgroundColor: '#f6f6f6',
          }}>
          {props.children}
        </div>
      </DocumentManagementTabLayout>
    </DocumentManagementLayout>
  )
}

export default ConnectedCommiteeDocumentLayout
